<template>
  <div class="position-management">
    <!-- 页面头部 -->
    <div class="header">
      <div class="header-left">
        <button class="back-btn" @click="goBack">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <div class="title">仓库管理</div>
      </div>
    </div>

    <!-- 操作工具栏 -->
    <div class="toolbar">
      <!-- <div class="toolbar-left">
        <div class="search-filters">
          <el-input v-model="query.eliteId" placeholder="eliteId" size="small" style="width: 120px;"></el-input>
        </div>
      </div> -->
      <div class="toolbar-right">
        <div style="width: 100%;display: flex; align-items: center; justify-content: space-between;gap: 10px;">
          <button class="btn btn-secondary" :disabled="loading" @click="loadAndCompare">
            {{ loading ? '加载中...' : '拉取并比对' }}
          </button>
          <button class="btn btn-outline" :disabled="loading || goods.length === 0" @click="compareGoodsDuplicates">
            商品库对比
          </button>
        </div>
      </div>
    </div>

    <!-- 结果区 -->
    <div class="content-table-container" style="padding: 10px;">
      <div style="display:flex;gap:10px;flex-wrap:wrap;font-size: 14px;">
        <span>攻略：<b>{{ guides.length }}</b></span>
        <span>商品库：<b>{{ goods.length }}</b></span>
        <span>待入库：<b style="color:#f59e0b">{{ toBeAdded.length }}</b></span>
        <span>待下架：<b style="color:#ef4444">{{ toBeRemoved.length }}</b></span>
      </div>

      <el-tabs v-model="activeTab">
        <el-tab-pane label="待入库攻略有库无" name="tab-added">
          <el-table :data="toBeAdded" style="width: 100%" height="calc(100vh - 220px)" empty-text="暂无待入库数据"
            v-loading="loading">
            <el-table-column prop="skuName" label="商品名" min-width="240" show-overflow-tooltip></el-table-column>
            <el-table-column prop="category" label="分类" width="120"></el-table-column>
            <el-table-column prop="materialUrl" label="链接" width="240">
              <template slot-scope="scope">
                <span>{{ scope.row.materialUrl || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="图片" width="80">
              <template slot-scope="scope">
                <img v-if="scope.row.imageUrl" :src="scope.row.imageUrl"
                  style="width:40px;height:40px;object-fit:cover;border-radius:4px;">
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="待下架库有攻略无" name="tab-removed">
          <el-table :data="toBeRemoved" style="width: 100%" height="calc(100vh - 250px)" empty-text="暂无待下架数据"
            v-loading="loading">
            <el-table-column prop="skuName" label="商品名" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="materialUrl" label="链接" width="240">
              <template slot-scope="scope">
                <span>{{ scope.row.materialUrl || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="图片" width="80">
              <template slot-scope="scope">
                <img :src="getImage(scope.row)" style="width:40px;height:40px;object-fit:cover;border-radius:4px;">
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="商品库重复" name="tab-duplicates">
          <el-table :data="duplicateGoods" style="width: 100%" height="calc(100vh - 250px)" empty-text="暂无重复数据"
            v-loading="loading">
            <el-table-column prop="skuName" label="商品名" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="_dupCount" label="重复次数" width="100"></el-table-column>
            <el-table-column prop="materialUrl" label="链接" width="240">
              <template slot-scope="scope">
                <span>{{ scope.row.materialUrl || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="图片" width="80">
              <template slot-scope="scope">
                <img :src="getImage(scope.row)" style="width:40px;height:40px;object-fit:cover;border-radius:4px;">
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getPromotionContent, queryGoodsByEliteId, getEnumValuesLiberayIds } from '@/utils/jdApi'

export default {
  name: 'LiberayManagement',
  data() {
    return {
      loading: false,
      // 入参
      query: {
        eliteId: 1001,
        pageIndex: 1,
        pageSize: 60,
        sortName: 'commission',
      },
      groupIds: [],
      // 数据源
      guides: [],
      goods: [],
      activeTab: 'tab-added'
    }
  },
  computed: {
    toBeAdded() {
      // 攻略里有，但商品库没有
      const goodsNames = new Set(this.goods.map(g => this.normalizeName(this.pickSkuName(g))))
      return this.guides.filter(item => {
        const name = this.normalizeName(item.skuName)
        return name && !goodsNames.has(name)
      })
    },
    toBeRemoved() {
      // 商品库有，但攻略没有
      const guideNames = new Set(this.guides.map(g => this.normalizeName(g.skuName)))
      return this.goods
        .map(g => {
          const n = this.pickSkuName(g)
          return { ...g, skuName: n }
        })
        .filter(item => {
          const name = this.normalizeName(item.skuName)
          return name && !guideNames.has(name)
        })
    },
    duplicateGoods() {
      const map = new Map()
      this.goods.forEach(item => {
        const name = this.normalizeName(this.pickSkuName(item))
        if (!name) return
        if (!map.has(name)) {
          map.set(name, [])
        }
        map.get(name).push(item)
      })

      const result = []
      map.forEach((list, name) => {
        if (list.length > 1) {
          list.forEach(g => {
            result.push({
              ...g,
              skuName: this.pickSkuName(g) || name,
              _dupCount: list.length
            })
          })
        }
      })
      return result
    }
  },
  mounted() {
    this.loadAndCompare()
  },
  methods: {
    async loadAndCompare() {
      this.loading = true
      try {
        // 先尝试从枚举表加载 liberay IDs 配置
      try {
        // 使用优化后的专用接口，只获取liberayIds字段，提高性能
        const enumRes = await getEnumValuesLiberayIds()
        if (enumRes && enumRes.success && enumRes.data && enumRes.data.length > 0) {
          this.groupIds = enumRes.data[0].liberayIds || []
        }
        } catch (e) {
          return this.$message.error('无法从枚举表加载 liberayIds，请先配置枚举值')
        }
        // 1) 拉取攻略（只取启用，page=0 size=10000）
        const guidesRes = await getPromotionContent({ page: 0, size: 10000 })
        const guides = guidesRes?.data || []

        // 2) 拉取商品库（精选接口）
        const goodsRes = await queryGoodsByEliteId({
          eliteId: Number(this.query.eliteId),
          pageIndex: Number(this.query.pageIndex),
          pageSize: Number(this.query.pageSize),
          sortName: this.query.sortName || undefined,
          groupId: this.groupIds
        })
        const goods = goodsRes?.data || []

        this.guides = Array.isArray(guides) ? guides : []
        this.goods = Array.isArray(goods) ? goods : []
      } catch (e) {
        this.$message.error( '加载失败')
      } finally {
        this.loading = false
      }
    },
    normalizeName(name) {
      if (!name) return ''
      return String(name).trim()
    },
    pickSkuName(goodsItem) {
      return goodsItem?.skuName || goodsItem?.sku_name || ''
    },
    getImage(g) {
      // 京东返回字段可能为 imageInfo.imageList[0].url
      const list = g?.imageInfo?.imageList
      if (Array.isArray(list) && list.length > 0 && list[0]?.url) return list[0].url
      return g?.imgUrl || ''
    },
    getPrice(g) {
      const price = g?.priceInfo?.price || g?.price
      return price ? price : '-'
    },
    compareGoodsDuplicates() {
      if (this.goods.length === 0) {
        this.$message.warning('请先拉取商品库数据')
        return
      }
      if (this.duplicateGoods.length === 0) {
        this.$message.success('商品库未检测到重复数据')
      } else {
        const uniqueDup = new Set()
        this.duplicateGoods.forEach(item => {
          const name = this.normalizeName(item.skuName)
          if (name) {
            uniqueDup.add(name)
          }
        })
        this.$message.info(`检测到 ${uniqueDup.size} 个重复商品，共 ${this.duplicateGoods.length} 条记录`)
        this.activeTab = 'tab-duplicates'
      }
    },
    goBack() {
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped lang="scss">
.position-management {
  margin: 0 auto;
  padding: 10px;
  background: #f8f9fa;
  height: 100vh;
  box-sizing: border-box;
}

.header {
  background: linear-gradient(135deg, #42b983, #369870);
  color: white;
  padding: 4px;
  margin-bottom: 10px;
  flex-shrink: 0;
  border-radius: 12px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  color: white;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.back-btn svg {
  width: 20px;
  height: 20px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: white;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
  gap: 10px;
}

.toolbar-left {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
}

.search-filters {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.search-filters .el-input {
  width: 150px;
}

.search-filters .el-select {
  width: 120px;
}

.btn {
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  outline: none;
  flex: 1;
}

.btn-primary {
  background: #42b983;
  color: white;
}

.btn-primary:hover {
  background: #369870;
}

.btn-secondary {
  background: #42b983;
  color: white;
}

.btn-secondary:hover {
  background: #42b983;
}

.btn-outline {
  background: transparent;
  color: #42b983;
  border: 1px solid #42b983;
}

.btn-outline:hover {
  background: #42b983;
  color: white;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.content-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* el-table 自定义样式 */
.content-table-container .el-table {
  border: none;
}

.content-table-container .el-table th {
  background: #f8f9fa;
  color: #495057;
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
}

.content-table-container .el-table td {
  border-bottom: 1px solid #f1f3f4;
}

.content-table-container .el-table tbody tr:hover {
  background-color: #f8f9fa;
}

/* 操作按钮样式 */
.content-table-container .el-button--mini {
  padding: 5px 8px;
  margin: 0 2px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 20px;
  background: white;
}

.pagination button {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
  border-radius: 4px;
}

.pagination button:hover:not(:disabled) {
  background: #f8f9fa;
}

.pagination button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 10px;
  border-radius: 8px;
  width: 500px;
  max-width: 90vw;
  margin: 10px;
}

.modal-content h3 {
  margin-top: 0;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.btn1 {
  padding: 0px 10px;
  background: #fff;
  border: 1px solid #42b983;
  color: #42b983;
  border-radius: 4px;
}

::v-deep {
  .el-tabs__header {
    margin: 0px !important;
  }
}
</style>